module.exports = __webpack_public_path__ + "static/img/9.10ce142.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/9.png
// module id = oraX
// module chunks = 0